import FetchPromise from '~/agent/fetch-promise';

export const createAIAnswer = (question: string) =>
  FetchPromise.post('learner_search_answers', {
    question,
  });
